import {HomeMatchSurveyDto} from "../types/home_match_preferences";

export enum HomeMatchPreferencesWizardStep {
    LOCATION = "location",
    COMPLETION_DATE = "completionDate",
    BUDGET = "budget",
    ROOMS = "rooms",
    SUMMARY = "summary",
    PHONE = "phone",
    SMS = "sms"
}

export type HomeMatchPreferencesWizardSurveyStep =
    | HomeMatchPreferencesWizardStep.LOCATION
    | HomeMatchPreferencesWizardStep.BUDGET
    | HomeMatchPreferencesWizardStep.ROOMS;

export type HomeMatchPreferencesWizardParameterStep = HomeMatchPreferencesWizardSurveyStep | HomeMatchPreferencesWizardStep.COMPLETION_DATE;

export const isHomeMatchPreferencesWizardSurveyStep = (step: HomeMatchPreferencesWizardStep): step is HomeMatchPreferencesWizardSurveyStep =>
    step === HomeMatchPreferencesWizardStep.LOCATION || step === HomeMatchPreferencesWizardStep.BUDGET || step === HomeMatchPreferencesWizardStep.ROOMS;

export const isHomeMatchPreferencesWizardParameterStep = (step: HomeMatchPreferencesWizardStep): step is HomeMatchPreferencesWizardParameterStep =>
    isHomeMatchPreferencesWizardSurveyStep(step) || step === HomeMatchPreferencesWizardStep.COMPLETION_DATE;

interface IGetVisibleHomeMatchPreferencesWizardStepParams {
    editingStep: HomeMatchPreferencesWizardSurveyStep | null;
    isChangingPhone: boolean;
    step: HomeMatchPreferencesWizardStep;
}

// The one step the user currently sees: changing the phone and editing from the summary both override the current step.
export const getVisibleHomeMatchPreferencesWizardStep = (params: IGetVisibleHomeMatchPreferencesWizardStepParams) => {
    const {editingStep, isChangingPhone, step} = params;

    if (isChangingPhone) return HomeMatchPreferencesWizardStep.PHONE;

    return editingStep ?? step;
};

export type HomeMatchPreferencesWizardEntry = "homeMatch" | "parameter";

type HomeMatchPreferencesWizardCompletion = "recommendations" | "dashboard";

export type IHomeMatchPreferencesWizardSurvey = Pick<HomeMatchSurveyDto, "price" | "regions" | "rooms"> &
    Partial<Pick<HomeMatchSurveyDto, "construction_end_date" | "floors_preference" | "high_rise_buildings" | "low_rise_buildings" | "market_types" | "types">>;

interface IGetHomeMatchPreferencesWizardStepsParams {
    entry: HomeMatchPreferencesWizardEntry;
    phone: string | null;
    phoneVerified: boolean;
    startStep?: HomeMatchPreferencesWizardParameterStep;
    survey: IHomeMatchPreferencesWizardSurvey | null | undefined;
}

export interface IHomeMatchPreferencesWizardPlan {
    completion: HomeMatchPreferencesWizardCompletion;
    initialStep: HomeMatchPreferencesWizardStep | null;
    steps: HomeMatchPreferencesWizardStep[];
}

const getMissingSurveySteps = (survey: IHomeMatchPreferencesWizardSurvey | null | undefined): HomeMatchPreferencesWizardSurveyStep[] => {
    const steps: HomeMatchPreferencesWizardSurveyStep[] = [];

    if (!survey?.regions?.length) {
        steps.push(HomeMatchPreferencesWizardStep.LOCATION);
    }

    if (survey?.price == null) {
        steps.push(HomeMatchPreferencesWizardStep.BUDGET);
    }

    if (survey?.rooms == null) {
        steps.push(HomeMatchPreferencesWizardStep.ROOMS);
    }

    return steps;
};

const getPhoneSteps = (phone: string | null, phoneVerified: boolean): HomeMatchPreferencesWizardStep[] => {
    if (phoneVerified) {
        return [];
    }

    if (!phone?.trim()) {
        return [HomeMatchPreferencesWizardStep.PHONE, HomeMatchPreferencesWizardStep.SMS];
    }

    return [HomeMatchPreferencesWizardStep.SMS];
};

export const getHomeMatchPreferencesWizardResumeStepIndex = (
    steps: HomeMatchPreferencesWizardStep[],
    survey: IHomeMatchPreferencesWizardSurvey | null | undefined
) => {
    const resumeStep = getMissingSurveySteps(survey)[0] ?? HomeMatchPreferencesWizardStep.SUMMARY;

    return Math.max(steps.indexOf(resumeStep), 0);
};

export const getHomeMatchPreferencesWizardSteps = (params: IGetHomeMatchPreferencesWizardStepsParams): IHomeMatchPreferencesWizardPlan => {
    const {entry, phone, phoneVerified, startStep, survey} = params;

    if (entry === "parameter" && startStep) {
        return {
            completion: "dashboard",
            initialStep: startStep,
            steps: [startStep]
        };
    }

    const surveyStepsInSession = getMissingSurveySteps(survey);
    const steps: HomeMatchPreferencesWizardStep[] = [
        ...surveyStepsInSession,
        ...(surveyStepsInSession.length ? [HomeMatchPreferencesWizardStep.SUMMARY] : []),
        ...getPhoneSteps(phone, phoneVerified)
    ];
    const initialStep = steps[0] ?? null;

    return {
        completion: entry === "homeMatch" ? "recommendations" : "dashboard",
        initialStep,
        steps
    };
};
import {HomeMatchSurveyDto} from "../types/home_match_preferences";

export enum HomeMatchPreferencesWizardStep {
    LOCATION = "location",
    COMPLETION_DATE = "completionDate",
    BUDGET = "budget",
    ROOMS = "rooms",
    SUMMARY = "summary",
    PHONE = "phone",
    SMS = "sms"
}

export type HomeMatchPreferencesWizardSurveyStep =
    | HomeMatchPreferencesWizardStep.LOCATION
    | HomeMatchPreferencesWizardStep.BUDGET
    | HomeMatchPreferencesWizardStep.ROOMS;

export type HomeMatchPreferencesWizardParameterStep = HomeMatchPreferencesWizardSurveyStep | HomeMatchPreferencesWizardStep.COMPLETION_DATE;

export const isHomeMatchPreferencesWizardSurveyStep = (step: HomeMatchPreferencesWizardStep): step is HomeMatchPreferencesWizardSurveyStep =>
    step === HomeMatchPreferencesWizardStep.LOCATION || step === HomeMatchPreferencesWizardStep.BUDGET || step === HomeMatchPreferencesWizardStep.ROOMS;

export const isHomeMatchPreferencesWizardParameterStep = (step: HomeMatchPreferencesWizardStep): step is HomeMatchPreferencesWizardParameterStep =>
    isHomeMatchPreferencesWizardSurveyStep(step) || step === HomeMatchPreferencesWizardStep.COMPLETION_DATE;

interface IGetVisibleHomeMatchPreferencesWizardStepParams {
    editingStep: HomeMatchPreferencesWizardSurveyStep | null;
    isChangingPhone: boolean;
    step: HomeMatchPreferencesWizardStep;
}

// The one step the user currently sees: changing the phone and editing from the summary both override the current step.
export const getVisibleHomeMatchPreferencesWizardStep = (params: IGetVisibleHomeMatchPreferencesWizardStepParams) => {
    const {editingStep, isChangingPhone, step} = params;

    if (isChangingPhone) return HomeMatchPreferencesWizardStep.PHONE;

    return editingStep ?? step;
};

export type HomeMatchPreferencesWizardEntry = "homeMatch" | "parameter";

type HomeMatchPreferencesWizardCompletion = "recommendations" | "dashboard";

export type IHomeMatchPreferencesWizardSurvey = Pick<HomeMatchSurveyDto, "price" | "regions" | "rooms"> &
    Partial<Pick<HomeMatchSurveyDto, "construction_end_date" | "floors_preference" | "high_rise_buildings" | "low_rise_buildings" | "market_types" | "types">>;

interface IGetHomeMatchPreferencesWizardStepsParams {
    entry: HomeMatchPreferencesWizardEntry;
    phone: string | null;
    phoneVerified: boolean;
    startStep?: HomeMatchPreferencesWizardParameterStep;
    survey: IHomeMatchPreferencesWizardSurvey | null | undefined;
}

export interface IHomeMatchPreferencesWizardPlan {
    completion: HomeMatchPreferencesWizardCompletion;
    initialStep: HomeMatchPreferencesWizardStep | null;
    steps: HomeMatchPreferencesWizardStep[];
}

const getMissingSurveySteps = (survey: IHomeMatchPreferencesWizardSurvey | null | undefined): HomeMatchPreferencesWizardSurveyStep[] => {
    const steps: HomeMatchPreferencesWizardSurveyStep[] = [];

    if (!survey?.regions?.length) {
        steps.push(HomeMatchPreferencesWizardStep.LOCATION);
    }

    if (survey?.price == null) {
        steps.push(HomeMatchPreferencesWizardStep.BUDGET);
    }

    if (survey?.rooms == null) {
        steps.push(HomeMatchPreferencesWizardStep.ROOMS);
    }

    return steps;
};

const getPhoneSteps = (phone: string | null, phoneVerified: boolean): HomeMatchPreferencesWizardStep[] => {
    if (phoneVerified) {
        return [];
    }

    if (!phone?.trim()) {
        return [HomeMatchPreferencesWizardStep.PHONE, HomeMatchPreferencesWizardStep.SMS];
    }

    return [HomeMatchPreferencesWizardStep.SMS];
};

export const getHomeMatchPreferencesWizardResumeStepIndex = (
    steps: HomeMatchPreferencesWizardStep[],
    survey: IHomeMatchPreferencesWizardSurvey | null | undefined
) => {
    const resumeStep = getMissingSurveySteps(survey)[0] ?? HomeMatchPreferencesWizardStep.SUMMARY;

    return Math.max(steps.indexOf(resumeStep), 0);
};

export const getHomeMatchPreferencesWizardSteps = (params: IGetHomeMatchPreferencesWizardStepsParams): IHomeMatchPreferencesWizardPlan => {
    const {entry, phone, phoneVerified, startStep, survey} = params;

    if (entry === "parameter" && startStep) {
        return {
            completion: "dashboard",
            initialStep: startStep,
            steps: [startStep]
        };
    }

    const surveyStepsInSession = getMissingSurveySteps(survey);
    const steps: HomeMatchPreferencesWizardStep[] = [
        ...surveyStepsInSession,
        ...(surveyStepsInSession.length ? [HomeMatchPreferencesWizardStep.SUMMARY] : []),
        ...getPhoneSteps(phone, phoneVerified)
    ];
    const initialStep = steps[0] ?? null;

    return {
        completion: entry === "homeMatch" ? "recommendations" : "dashboard",
        initialStep,
        steps
    };
};
